module.exports = __webpack_public_path__ + "static/media/default-avatar.29753109.png";